module.exports = __webpack_public_path__ + "static/assets/8478a429265453727aa1a8409684376c.svg";